export default "__VITE_ASSET__Bwh_frfY__"